/**
 * Mobile Infinite Scroll for Product Media Gallery
 * Enables seamless looping: scrolling past the last image shows the first, and vice versa
 */

function initInfiniteScroll() {
  // Only run on mobile (less than 990px)
  if (window.innerWidth >= 990) return;

  const carousel = document.querySelector('.myProductGallery');
  if (!carousel) return;

  const items = Array.from(carousel.querySelectorAll('.product-media-list-item:not([data-clone])'));
  if (items.length <= 1) return; // No need for infinite scroll with 1 or 0 items

  let isLooping = false;
  let scrollTimeout;

  // Clone first and last items for seamless infinite effect
  const firstClone = items[0].cloneNode(true);
  const lastClone = items[items.length - 1].cloneNode(true);

  // Mark clones so we can identify them
  firstClone.setAttribute('data-clone', 'first');
  lastClone.setAttribute('data-clone', 'last');

  // Remove indicators from clones to avoid duplicate counters
  const firstCloneIndicator = firstClone.querySelector('.indicator');
  const lastCloneIndicator = lastClone.querySelector('.indicator');
  if (firstCloneIndicator) firstCloneIndicator.remove();
  if (lastCloneIndicator) lastCloneIndicator.remove();

  // Remove any Alpine.js attributes to prevent conflicts
  firstClone.removeAttribute('x-ref');
  lastClone.removeAttribute('x-ref');
  firstClone.removeAttribute(':class');
  lastClone.removeAttribute(':class');
  
  // Remove IDs to prevent duplicate ID issues
  const firstCloneId = firstClone.getAttribute('id');
  const lastCloneId = lastClone.getAttribute('id');
  if (firstCloneId) firstClone.setAttribute('id', firstCloneId + '-clone');
  if (lastCloneId) lastClone.setAttribute('id', lastCloneId + '-clone');

  // Keep media wrapper attributes but make them inert for the carousel module
  // This allows videos to play but prevents carousel event conflicts
  const firstCloneMedia = firstClone.querySelector('[data-product-single-media-wrapper]');
  const lastCloneMedia = lastClone.querySelector('[data-product-single-media-wrapper]');
  
  // Remove ARIA attributes that might confuse screen readers
  const removeAriaAttrs = (element) => {
    element.removeAttribute('role');
    element.removeAttribute('aria-roledescription');
    element.removeAttribute('aria-label');
  };
  
  removeAriaAttrs(firstClone);
  removeAriaAttrs(lastClone);

  // Append first item clone to end, prepend last item clone to start
  carousel.appendChild(firstClone);
  carousel.insertBefore(lastClone, items[0]);

  // Set initial scroll position to show real first item
  setTimeout(() => {
    const realFirstItem = carousel.querySelector('.product-media-list-item:not([data-clone])');
    if (realFirstItem) {
      carousel.scrollTo({
        left: realFirstItem.offsetLeft,
        behavior: 'instant'
      });
    }
  }, 0);

  // Handle scroll events with improved detection
  carousel.addEventListener('scroll', () => {
    if (isLooping) return;

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      checkAndLoop();
    }, 300); // Slightly longer delay for better stability
  }, { passive: true });

  function checkAndLoop() {
    if (isLooping) return;

    const scrollLeft = carousel.scrollLeft;
    const carouselWidth = carousel.offsetWidth;
    const scrollWidth = carousel.scrollWidth;
    
    // Calculate thresholds (allow some tolerance)
    const threshold = carouselWidth * 0.1;
    
    // If scrolled all the way to the left (showing last clone)
    if (scrollLeft < threshold) {
      isLooping = true;
      // Find the real last item
      const realLastItem = items[items.length - 1];
      
      // Disable scroll snapping temporarily for smooth transition
      carousel.style.scrollSnapType = 'none';
      
      carousel.scrollTo({
        left: realLastItem.offsetLeft,
        behavior: 'instant'
      });
      
      // Trigger media visibility events for proper video/media handling
      setTimeout(() => {
        const mediaWrapper = realLastItem.querySelector('[data-product-single-media-wrapper]');
        if (mediaWrapper) {
          mediaWrapper.dispatchEvent(new CustomEvent('mediaVisible'));
        }
        
        // Re-enable scroll snapping
        carousel.style.scrollSnapType = '';
        isLooping = false;
      }, 150);
    }
    // If scrolled all the way to the right (showing first clone)
    else if (scrollLeft > scrollWidth - carouselWidth - threshold) {
      isLooping = true;
      // Find the real first item
      const realFirstItem = items[0];
      
      // Disable scroll snapping temporarily for smooth transition
      carousel.style.scrollSnapType = 'none';
      
      carousel.scrollTo({
        left: realFirstItem.offsetLeft,
        behavior: 'instant'
      });
      
      // Trigger media visibility events for proper video/media handling
      setTimeout(() => {
        const mediaWrapper = realFirstItem.querySelector('[data-product-single-media-wrapper]');
        if (mediaWrapper) {
          mediaWrapper.dispatchEvent(new CustomEvent('mediaVisible'));
        }
        
        // Re-enable scroll snapping
        carousel.style.scrollSnapType = '';
        isLooping = false;
      }, 150);
    }
  }

  // Re-initialize on resize if crossing the mobile/desktop breakpoint
  let wasDesktop = window.innerWidth >= 990;
  window.addEventListener('resize', () => {
    const isDesktop = window.innerWidth >= 990;
    if (wasDesktop !== isDesktop) {
      wasDesktop = isDesktop;
      if (isDesktop) {
        // Switched to desktop - remove clones
        const clones = carousel.querySelectorAll('[data-clone]');
        clones.forEach(clone => clone.remove());
      }
    }
  });
}

// Initialize when DOM is ready and after Alpine.js has initialized
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initInfiniteScroll, 500);
  });
} else {
  setTimeout(initInfiniteScroll, 500);
}

export default initInfiniteScroll;
